export default function() {
  const carousel = document.querySelector('.carousel-inner');
  const slides = Array.from(carousel.children);

  let indexNum = slides.length - 1;
  let index = 0;
  let indexPrev = indexNum;
  let indexNext = 1;

  let Next = () => {
    setTimeout(() => {
      slides[index].classList.add('carousel-item-left');

      setTimeout(() => {
        slides[index].classList.remove('active');
        slides[index].classList.remove('carousel-item-left');

        if (index >= indexNum) {
          index = 0;
        } else {
          index++;
        }
      }, 600);

      slides[indexNext].classList.add('carousel-item-next');

      setTimeout(() => {
        slides[indexNext].classList.add('carousel-item-left');
      }, 20);

      setTimeout(() => {
        slides[indexNext].classList.remove('carousel-item-next');
        slides[indexNext].classList.remove('carousel-item-left');
        slides[indexNext].classList.add('active');

        if (indexNext >= indexNum) {
          indexNext = 0;
        } else {
          indexNext = index + 1;
        }

        if (indexPrev == 3) {
          indexPrev = 0;
        } else {
          indexPrev++;
        }
      }, 600);
    }, 20);
  };
  setInterval(() => {
    Next();
  }, 5000);
}
